import { render, staticRenderFns } from "./CatalogProductFinder.vue?vue&type=template&id=50158f0f&"
import script from "./CatalogProductFinder.vue?vue&type=script&lang=js&"
export * from "./CatalogProductFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports